module.exports = __webpack_public_path__ + "img/hot-text.90481211.png";